import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { SemiDarkLayoutComponent } from './layouts/semi-dark-layout/semi-dark-layout.component';
import { DarkLayoutComponent } from './layouts/dark-layout/dark-layout.component';
import { LightLayoutComponent } from './layouts/light-layout/light-layout.component';
import { StaticLayoutComponent } from './layouts/static-layout/static-layout.component';
import { BoxedLayoutComponent } from './layouts/boxed-layout/boxed-layout.component';
import { FixedLayoutComponent } from './layouts/fixed-layout/fixed-layout.component';
import { FixedNavbarFooterLayoutComponent } from './layouts/fixed-navbar-footer-layout/fixed-navbar-footer-layout.component';
import { FixedNavbarNavigationLayoutComponent } from './layouts/fixed-navbar-navigation-layout/fixed-navbar-navigation-layout.component';
import { FixedNavigationLayoutComponent } from './layouts/fixed-navigation-layout/fixed-navigation-layout.component';
import { FixedNavbarLayoutComponent } from './layouts/fixed-navbar-layout/fixed-navbar-layout.component';
import { DetachedRightSidebarLayoutComponent } from './layouts/detached-right-sidebar-layout/detached-right-sidebar-layout.component';
import { DetachedStickyRightSidebarLayoutComponent } from './layouts/detached-sticky-right-sidebar-layout/detached-sticky-right-sidebar-layout.component';
import { DetachedStickyLeftSidebarLayoutComponent } from './layouts/detached-sticky-left-sidebar-layout/detached-sticky-left-sidebar-layout.component';
import { DetachedLeftSidebarLayoutComponent } from './layouts/detached-left-sidebar-layout/detached-left-sidebar-layout.component';
import { OneColumnLayoutComponent } from './layouts/1-column-layout/1-column-layout.component';
import { TwoColumnsLayoutComponent } from './layouts/2-columns-layout/2-columns-layout.component';


import { ONE_COLUMN_ROUTES } from "./shared/routes/1-column-layout.routes";
import { TWO_COLUMN_ROUTES } from "./shared/routes/2-columns-layout.routes";
import { BOXED_ROUTES } from "./shared/routes/boxed-layout.routes";
import { DARK_ROUTES } from "./shared/routes/dark-layout.routes";
import { DETACHED_LEFT_SIDEBAR_ROUTES } from "./shared/routes/detached-left-sidebar-layout.routes";
import { DETACHED_RIGHT_SIDEBAR_ROUTES } from "./shared/routes/detached-right-sidebar-layout.routes";
import { DETACHED_STICKY_LEFT_SIDEBAR_ROUTES } from "./shared/routes/detached-sticky-left-sidebar-layout.routes";
import { DETACHED_STICKY_RIGHT_SIDEBAR_ROUTES } from "./shared/routes/detached-sticky-right-sidebar-layout.routes";
import { FIXED_ROUTES } from "./shared/routes/fixed-layout.routes";
import { FIXED_NAVBAR_FOOTER_ROUTES } from "./shared/routes/fixed-navbar-footer-layout.routes";
import { FIXED_NAVBAR_ROUTES } from "./shared/routes/fixed-navbar-layout.routes";
import { FIXED_NAVBAR_NAVIGATION_ROUTES } from "./shared/routes/fixed-navbar-navigation-layout.routes";
import { FIXED_NAVIGATION_ROUTES } from "./shared/routes/fixed-navigation-layout.routes";
import { LIGHT_ROUTES } from "./shared/routes/light-layout.routes";
import { SEMI_DARK_ROUTES } from "./shared/routes/semi-dark-layout.routes";
import { STATIC_ROUTES } from "./shared/routes/static-layout.routes";

import { AuthGuard } from './shared/auth/auth-guard.service';
import {SignInComponent} from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import {FeaturedEventComponent} from './layouts/featured-event/featured-event.component';
import {FEATURED_EVENT_ROUTES} from './shared/routes/featured-events.routes';
import {NonFeaturedEventComponent} from './layouts/non-featured-event/non-featured-event.component';
import {NON_FEATURED_EVENT_ROUTES} from './shared/routes/non-featured-events.routes';
import {SettingsComponent} from './layouts/settings/settings.component';
import {SETTINGS_ROUTES} from './shared/routes/setting.routes';
import {MESSAGES_ROUTES} from './shared/routes/messages.routes';
import {MessagesComponent} from './layouts/messages/messages.component';
import {MembersComponent} from './layouts/members/members.component';
import {MEMBERS_ROUTES} from './shared/routes/members.routes';
import {MessagesHistoryComponent} from './layouts/messages-history/messages-history.component';
import {MESSAGES_HISTORY_ROUTES} from './shared/routes/messages-history.routes';
import {PersonalTrainersComponent} from './layouts/personal-trainers/personal-trainers.component';
import {PERSONAL_TRAINERS_ROUTES} from './shared/routes/personal-trainers.routes';
import {PersonalTrainersEventsComponent} from './layouts/personal-trainers-events/personal-trainers-events.component';
import {PERSONAL_TRAINERS_EVENTS_ROUTES} from './shared/routes/personal-trainers-events';
import {AllReportsComponent} from './layouts/all-reports/all-reports.component';
import {ALL_REPORTS_ROUTES} from './shared/routes/all-reports.routes';
import {ACCOUNT_ROUTES} from './shared/routes/account.routes';
import {AccountComponent} from './layouts/account/account.component';
import {AdminComponent} from './layouts/admin/admin.component';
import {ADMIN_ROUTES} from './shared/routes/admin.routes';
import {RoleGuard} from './shared/auth/role-guard.service';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'gym-owners/auth/user-board/featured-events',
    pathMatch: 'full',

  },
  { path: 'login', component: SignInComponent},
  { path: 'sign-up', component: SignUpComponent},
  //super admin routes
  {path: '', component: AdminComponent, children: ADMIN_ROUTES, canActivate: [RoleGuard]},

  //gym owner-routes
  { path: '', component: FeaturedEventComponent, children: FEATURED_EVENT_ROUTES, canActivate: [AuthGuard]},
  { path: '', component: NonFeaturedEventComponent, children: NON_FEATURED_EVENT_ROUTES, canActivate: [AuthGuard]},
  { path: '', component: MembersComponent, children: MEMBERS_ROUTES, canActivate: [AuthGuard]},
  { path: '', component: SettingsComponent, children: SETTINGS_ROUTES, canActivate: [AuthGuard]},
  { path: '', component: MessagesComponent, children: MESSAGES_ROUTES, canActivate: [AuthGuard]},
  { path: '', component: MessagesHistoryComponent, children: MESSAGES_HISTORY_ROUTES, canActivate: [AuthGuard]},
  { path: '', component: PersonalTrainersComponent, children: PERSONAL_TRAINERS_ROUTES, canActivate: [AuthGuard]},
  { path: '', component: PersonalTrainersEventsComponent, children: PERSONAL_TRAINERS_EVENTS_ROUTES, canActivate: [AuthGuard]},
  {path: '', component: AllReportsComponent, children: ALL_REPORTS_ROUTES, canActivate: [AuthGuard]},
  {path: '', component: AccountComponent, children: ACCOUNT_ROUTES, canActivate: [AuthGuard]},



  { path: '', component: OneColumnLayoutComponent, data: { title: '' }, children: ONE_COLUMN_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: TwoColumnsLayoutComponent, data: { title: '' }, children: TWO_COLUMN_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: BoxedLayoutComponent, data: { title: '' }, children: BOXED_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: DarkLayoutComponent, data: { title: '' }, children: DARK_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: DetachedLeftSidebarLayoutComponent, data: { title: '' }, children: DETACHED_LEFT_SIDEBAR_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: DetachedRightSidebarLayoutComponent, data: { title: '' }, children: DETACHED_RIGHT_SIDEBAR_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: DetachedStickyLeftSidebarLayoutComponent, data: { title: '' }, children: DETACHED_STICKY_LEFT_SIDEBAR_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: DetachedStickyRightSidebarLayoutComponent, data: { title: '' }, children: DETACHED_STICKY_RIGHT_SIDEBAR_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: FixedLayoutComponent, data: { title: '' }, children: FIXED_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: FixedNavbarFooterLayoutComponent, data: { title: '' }, children: FIXED_NAVBAR_FOOTER_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: FixedNavbarLayoutComponent, data: { title: '' }, children: FIXED_NAVBAR_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: FixedNavbarNavigationLayoutComponent, data: { title: '' }, children: FIXED_NAVBAR_NAVIGATION_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: FixedNavigationLayoutComponent, data: { title: '' }, children: FIXED_NAVIGATION_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: LightLayoutComponent, data: { title: '' }, children: LIGHT_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: SemiDarkLayoutComponent, data: { title: '' }, children: SEMI_DARK_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: StaticLayoutComponent, data: { title: '' }, children: STATIC_ROUTES, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts